// A leading SELECT is SQL; a leading WITH only once it opens a CTE (`with x as
// (`), since "with customers in Portugal" is a search phrase, and routing it to
// SQL would run it instead of searching, and take Ask AI away.
const SQL_RE =
  /^\s*(select\b|with\s+(recursive\s+)?("[^"]+"|[a-z_][a-z0-9_]*)\s*(\([^)]*\))?\s+as(\s+(not\s+)?materialized)?\s*\()/i;

// A FROM whose table name is still being typed at the caret: the optional
// group captures an opening double quote so the completion can close it.
const FROM_TARGET_RE = /\bfrom\s+("?)([A-Za-z0-9_]*)$/i;

export function isSqlQuery(text: string): boolean {
  return SQL_RE.test(text);
}

/**
 * What Tab would append to finish naming the open table, or null when there is
 * nothing to complete. `text` is the query up to the caret.
 */
export function suggestTableName(text: string, sqlName: string): string | null {
  const match = FROM_TARGET_RE.exec(text);
  if (!match) return null;

  const [, quote, typed] = match;
  if (!sqlName.toLowerCase().startsWith(typed.toLowerCase())) return null;

  const completion = sqlName.slice(typed.length) + (quote ? '"' : "");
  return completion === "" ? null : completion;
}
